import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import proveedorService from '../../services/proveedorService';
import { FaPlus, FaEdit, FaTrash, FaTruck } from 'react-icons/fa';

export default function ProveedoresPage() {
  const [proveedores,  setProveedores]  = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando,     setEditando]     = useState(null);

  const [form, setForm] = useState({
    razon_social: '', ruc: '', tipo_documento: 'RUC',
    email: '', telefono: '', direccion: '',
  });

  useEffect(() => { cargarDatos(); }, []);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const data = await proveedorService.listar();
      setProveedores(data);
    } finally {
      setCargando(false);
    }
  };

  const abrirModal = (proveedor = null) => {
    if (proveedor) {
      setEditando(proveedor);
      setForm({
        razon_social:   proveedor.razon_social,
        ruc:            proveedor.ruc || '',
        tipo_documento: proveedor.tipo_documento || 'RUC',
        email:          proveedor.email || '',
        telefono:       proveedor.telefono || '',
        direccion:      proveedor.direccion || '',
      });
    } else {
      setEditando(null);
      setForm({
        razon_social: '', ruc: '', tipo_documento: 'RUC',
        email: '', telefono: '', direccion: '',
      });
    }
    setMostrarModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editando) {
        await proveedorService.actualizar(editando.id, form);
      } else {
        await proveedorService.crear(form);
      }
      setMostrarModal(false);
      cargarDatos();
    } catch (err) {
      console.error('Error al guardar:', err);
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Desactivar este proveedor?')) return;
    await proveedorService.eliminar(id);
    cargarDatos();
  };

  return (
    <Layout>
      {/* Encabezado */}
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Proveedores</h4>
          <p>Gestión de proveedores registrados</p>
        </div>
        <button className="btn btn-danger" onClick={() => abrirModal()}>
          <FaPlus className="me-2" /> Nuevo Proveedor
        </button>
      </div>

      {/* Tabla */}
      <div className="card card-custom">
        <div className="card-body">
          {cargando ? (
            <div className="text-center py-4">
              <div className="spinner-custom mx-auto" />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-custom">
                <thead>
                  <tr>
                    <th>Razón Social</th>
                    <th>RUC/Doc</th>
                    <th>Tipo Doc</th>
                    <th>Email</th>
                    <th>Teléfono</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {proveedores.length > 0 ? (
                    proveedores.map((p) => (
                      <tr key={p.id}>
                        <td className="fw-bold">{p.razon_social}</td>
                        <td>{p.ruc || '—'}</td>
                        <td><span className="badge bg-secondary">{p.tipo_documento}</span></td>
                        <td>{p.email || '—'}</td>
                        <td>{p.telefono || '—'}</td>
                        <td>
                          <button className="btn btn-sm btn-outline-primary me-1" onClick={() => abrirModal(p)}>
                            <FaEdit />
                          </button>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => handleEliminar(p.id)}>
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted py-4">
                        <FaTruck size={32} className="mb-2 d-block mx-auto" />
                        Sin proveedores registrados
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {mostrarModal && (
        <div className="modal-overlay">
          <div className="modal-custom">
            <div className="modal-header-custom">
              <h5>{editando ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h5>
              <button className="btn-close-custom" onClick={() => setMostrarModal(false)}>×</button>
            </div>
            <div className="modal-body-custom">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">

                  <div className="col-md-8">
                    <label className="form-label">Razón Social *</label>
                    <input name="razon_social" className="form-control" value={form.razon_social} onChange={handleChange} required />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Tipo Documento</label>
                    <select name="tipo_documento" className="form-select" value={form.tipo_documento} onChange={handleChange}>
                      <option value="RUC">RUC</option>
                      <option value="DNI">DNI</option>
                      <option value="CE">CE</option>
                      <option value="PASAPORTE">Pasaporte</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">N° Documento</label>
                    <input name="ruc" className="form-control" value={form.ruc} onChange={handleChange} maxLength={20} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input name="email" type="email" className="form-control" value={form.email} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Teléfono</label>
                    <input name="telefono" className="form-control" value={form.telefono} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Dirección</label>
                    <input name="direccion" className="form-control" value={form.direccion} onChange={handleChange} />
                  </div>

                </div>

                <div className="d-flex gap-2 justify-content-end mt-3">
                  <button type="button" className="btn btn-secondary" onClick={() => setMostrarModal(false)}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-danger">
                    {editando ? 'Actualizar' : 'Guardar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}